import React, { useEffect, useState } from 'react'
import ItemsApp, { IItemModel } from './ItemsApp'
import NothingFound from '../../components/NothingFound'
import { error } from 'console'
import { useDispatch } from 'react-redux'
import { handleRequestError } from '../../services/api'
import { QRCodeSVG } from 'qrcode.react'
import Logo from "../../assets/logo/miraj-logo-black.svg"
import { Helmet } from 'react-helmet'

interface IProps {
    uniqueId: string
}

interface ISticker {
    uniqueId: string,
    title: string,
    serial_number: string
}

export function Sticker(props: ISticker){

    const { uniqueId, title, serial_number } = props

    return(
        <div className="sticker-box">
            <div className="content-of-sticker-box">

                <div className="qr-code-of-sticker-box">
                    <div className="content-of-qr-code-of-sticker-box">
                        <QRCodeSVG value={uniqueId} size={100} level="H" />
                    </div>
                </div>

                <div className="text-box-of-sticker-box">
                    <div className="content-of-text-box-of-sticker-box">
                         <h3>{title}</h3>
                         <h4>{uniqueId}</h4>
                         <h4>
                            <span className="bold-text">SN: </span>
                            {serial_number ? serial_number : "-"}
                        </h4>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default function ContainerQrCodes(props: IProps) {

    const dispatch = useDispatch()

    const { uniqueId } = props

    const [item, setItem] = useState<IItemModel | null>(null)
    const [items, setItems] = useState<IItemModel[]>([])

    const [stickers, setStickers] = useState<ISticker[]>([])

    const [loading, setLoading] = useState<boolean>(true)

    const [notFound, setNotFound] = useState<boolean>(false)

    const itemsApp = new ItemsApp()

    /**
     * Load item
     */
    const loadItem = () => {
        setLoading(true)
        itemsApp.singleItemDetailsByUniqueId(uniqueId)
            .then(response => {
                setItem(response.data)
                setLoading(false)
            })
            .catch(error => {

                setLoading(false)

                switch(error.response.status){

                    case 404:
                        setNotFound(true)
                        break

                    default:
                        handleRequestError(error, dispatch)
                }

            })
    }

    /**
     * Load items
     */
    const loadItems = () => {
        if (item){
            setLoading(true)
            itemsApp.returnContainerItemList(item.id)
                .then(response => {
                    setItems(response.data)
                    setLoading(false)
                })
                .catch(error => {
                    setLoading(false)
                    handleRequestError(error, dispatch)
                })
        }
    }

    /**
     * Load item
     */
    useEffect(() => {
        loadItem()
    }, [uniqueId])

    useEffect(() => {
        if (item){
            loadItems()
        }
    }, [item])

    /**
     * Update stickers
     */
    useEffect(() => {

        let newStickers: ISticker[] = []

        if (items.length > 0){
            items.map((item) => newStickers.push({
                title: item.title,
                uniqueId: item.unique_id,
                serial_number: item.serial_number
            }))
        }

        setStickers(newStickers)
    }, [item, items])

    if (notFound){
        return <NothingFound message="Item doesn't exist" />
    }

    return(
        <div className="container-item-stickers-container compact">

            <Helmet>
                <title>{item ? item.title + " - Qr Codes" : "Qr Codes"}</title>
            </Helmet>

            {/* <h1 className="title-h1">Container:</h1> */}

            {item && (
                <div className="header-of-container-item-stickers-container">
                    <div className="content-of-header-of-container-item-stickers-container">

                        <div className="qr-code-of-header-of-container-item-stickers-container">
                            <div className="content-of-qr-code-of-sticker-box">
                                <QRCodeSVG value={item.unique_id} size={100} level="H" />
                            </div>
                        </div>   

                        <div className="text-box-of-sticker-box">
                            <div className="content-of-text-box-of-sticker-box">
                                <h3>{item.title}</h3>
                                <h4>{uniqueId}</h4>
                                <h4>
                                    <span className="bold-text">SN: </span>
                                    {item.serial_number ? item.serial_number : "-"}
                                </h4>
                            </div>
                         </div>

                        <div className="logo-of-sticker-box">
                            <div className="content-of-logo-of-sticker-box">
                                <img src={Logo} />
                            </div>
                        </div>

                    </div>
                </div>
            )}

            {/* <h3 className="sub-title">Contains:</h3> */}

            <div className="content-of-container-item-stickers-container">

                {stickers.map((sticker, index: number) => <Sticker {...sticker} key={index} />)}

            </div>
        </div>
    )
}